import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { FETCH_BUY_NOW_OFFERS } from '../../redux/Offers';
import Table from '../Table/Table';
import { tablesHeaders } from '../../consts/tablesConf';
import { handleShowOffer } from '../../helpers/utils';
import { BUY_NOW } from '../../consts/navigation';
import SingleRow from '../Offers/SingleRow';
import { vehicleTypes } from '../../consts/vehicleTypes';

const BuyNowOffersContainer = ({ history, match, isMobile, fetchOffers, offers, vehicleType, }) => {

  const handleOfferDetails = (id, whichFolder) => {
    const isTextNotSelected = window.getSelection().toString() === '';
    if (isTextNotSelected) {
      handleShowOffer(id, history, match, whichFolder);
    }
  }

  return (
    <Table
      whichFolder={BUY_NOW}
      tableHeaders={tablesHeaders[vehicleType][BUY_NOW]}
      fetchOffers={fetchOffers}
      totalCount={get(offers, 'total_count')}
      totalPages={get(offers, 'total_pages')}
      isLoading={get(offers, 'isLoading')}
      renderRow={SingleRow(isMobile, vehicleType)}
      onRowClick={handleOfferDetails}
      items={get(offers, 'offers')}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    offers: get(state, ['offers']),
    isMobile: get(state, ['layout', 'isMobile']),
    vehicleType: get(state, ['vehicleType', 'vehicleType']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchOffers: () => dispatch(FETCH_BUY_NOW_OFFERS()),
  };
};

BuyNowOffersContainer.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  vehicleType: PropTypes.oneOf(Object.keys(vehicleTypes)).isRequired,
  fetchOffers: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  offers: PropTypes.shape({
    current_folder: PropTypes.string,
    new_offers_count: PropTypes.number,
    offers: PropTypes.array,
    total_count: PropTypes.number,
    total_pages: PropTypes.number,
    isLoading: PropTypes.bool,
  }).isRequired,
};
BuyNowOffersContainer.defaultProps = {
  isMobile: true,
};

export default connect(mapStateToProps, mapDispatchToProps)(BuyNowOffersContainer)
